import React from "react";
import styled from "styled-components";
import Navigation from "./Navigation";
import mvImage from "../assets/images/mv.jpg";

const HeaderContainer = styled.header`
  height: 600px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${mvImage});
  background-size: cover;
  background-position: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  text-align: center;
  position: relative;
`;

const HeaderContent = styled.div`
  max-width: 800px;
  padding: 0 2rem;
`;

const Title = styled.h1`
  font-size: 3.5rem;
  margin-bottom: 1rem;
  font-weight: 700;
`;

const Subtitle = styled.p`
  font-size: 1.5rem;
  margin-bottom: 2rem;
`;

const Button = styled.button`
  padding: 0.8rem 2rem;
  background-color: #0099cc;
  color: #fff;
  font-size: 1rem;
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.3s ease;

  &:hover {
    background-color: #007aa3;
  }
`;

const Header = ({ title, subtitle, showButton = true }) => {
  return (
    <HeaderContainer>
      <Navigation />
      <HeaderContent>
        <Title data-aos="fade-down" data-aos-delay="100">
          {title}
        </Title>
        <Subtitle data-aos="fade-up" data-aos-delay="300">
          {subtitle}
        </Subtitle>
        {showButton && (
          <Button data-aos="zoom-in" data-aos-delay="500">
            お問い合わせ
          </Button>
        )}
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;
